import messagesES from '@/plugins/i18n/locales/es'
import messagesEN from '@/plugins/i18n/locales/en'

import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// Locale inicial por defecto; se sincroniza con Vuex en main.js tras cargar el store
// (evita ciclo store → auth → i18n → store).
export const i18n = new VueI18n({
  locale: 'es',
  fallbackLocale: 'es',
  messages: {
    es: messagesES,
    en: messagesEN
  }, // set locale messages
})

const loadedLanguages = ['es', 'en'] // our default language that is preloaded

function setI18nLanguage(lang) {
  i18n.locale = lang

  return lang
}

export function loadLanguageAsync(lang) {
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language hasn't been loaded yet
  /* eslint-disable prefer-template */
  return import(/* webpackChunkName: "lang-[request]" */ '@/plugins/i18n/locales/' + lang + '.js').then(msgs => {
    i18n.setLocaleMessage(lang, msgs.default)
    loadedLanguages.push(lang)

    return setI18nLanguage(lang)
  })
  /* eslint-enable */
}
